import {
	IFinancialReportResponceWithPagination,
	IGetMaxBidsResponse,
	IGetParticipantsResponse,
	IGetUnpaidItemsResponse,
	IGetUnpaidTablesResponse,
	IOrganizationFullReportColumns,
} from '@/utils/types/organization-reports.interface';
import {StoreType} from '..';

export const getReportLoadingSelector = (state: StoreType): boolean => state.organizationReportStore.isLoading;

export const getUnpaidItemsSelector = (state: StoreType): IGetUnpaidItemsResponse | null =>
	state.organizationReportStore.unpaidItems;

export const getUnpaidTablesSelector = (state: StoreType): IGetUnpaidTablesResponse | null =>
	state.organizationReportStore.unpaidTables;

export const getMaxBidsSelector = (state: StoreType): IGetMaxBidsResponse | null =>
	state.organizationReportStore.maxBids;

export const getParticipantsSelector = (state: StoreType): IGetParticipantsResponse | null =>
	state.organizationReportStore.participants;

export const getFinancialReportSelector = (state: StoreType): IFinancialReportResponceWithPagination
 | null =>
	state.organizationReportStore.fullReport;

export const getReportColumnsSelector = (state: StoreType): IOrganizationFullReportColumns[] => state.organizationReportStore.columns;
